<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewals" title="Pending Payments" />
 
		<div class="container-fluid">
			
			<div class="card">
				<div class="card-body">

                    <div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-6 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchPendingPayments()">
										<option value="20">20</option>
										<option value="30">30</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-3 mb-2">
								
							</div>
							<div class="col-md-3">
								<input type="text" class="form-control" placeholder="IMEI" v-model="keyword" @keyup="fetchPendingPayments()"/>
							</div>
						</div>
					</div>
								
					<div class="table-responsive product-table">
						<table class="display" id="basic-1" >
							<thead>
								<tr align="center">
									<th>IMEI & ICCID</th>
									<th>Dealer</th>
                                    <th>Enquired By</th>
                                    <th>Request By</th>
                                    <th>Recharged By</th>
                                    <th>Payment By</th>
									<th>Renewal Type</th>
									<th>Payment Type</th>
									<th>Amount</th>
									<th>Payment Status</th>
                                    <th>Action</th>
								</tr>
							</thead>

							<tbody v-if="Boolean(payment_pending.length)">
								<tr v-for="(device) in payment_pending" :key="device.id" align="center">
                                    <td>{{ device.imei }} <br> {{ device.iccid }} <br> 
										<span v-if="device.vehicle_no">Vehicle No:{{ device.vehicle_no }}</span>
									</td>
                                    <td>{{ device.dealer_name }}</td>
                                    <td>
										{{ device.enquiry_by_name || '-' }}<br>
										{{ device.enquiry_on ? $filters.formatDateTime(device.enquiry_on) : '' }}
									</td>
									<td>
										{{ device.requested_by_name }}<br>
										{{ device.requested_on ? $filters.formatDateTime(device.requested_on) : '' }}
									</td>
									<td>
										{{ device.recharged_by_name }}<br>
										{{ device.recharged_on ? $filters.formatDateTime(device.recharged_on) : '' }}
									</td>
									<td>
										{{ device.paid_by_name || '-' }}<br>
										{{ device.payment_on ? $filters.formatDateTime(device.payment_on) : '' }}
									</td>
									<td>
										<div v-if="device.is_topup==1">
                                            <span class="badge rounded-pill bg-success">Topup</span> <br>
                                        </div>
                                        <div v-else>
											<span class="badge rounded-pill bg-primary" v-if="device.renewal_type==1">Normal</span>
											<span class="badge rounded-pill bg-info" v-if="device.renewal_type==2">SIM Change</span>
											<span class="badge rounded-pill bg-primary" v-if="device.renewal_type==3">Replacement</span>
											<span class="badge rounded-pill bg-info" v-if="device.renewal_type==4">Noraml SIM Change</span>
											<span class="badge rounded-pill bg-secondary" v-if="device.renewal_type==5">Extension</span>
										</div>
									
										<span v-if="device.renewal_type== 2 || device.renewal_type== 4">
                                            <span class="badge rounded-pill bg-info" v-if="device.sim_change_status==1">Pending</span>
                                            <span class="badge rounded-pill bg-success" v-if="device.sim_change_status==2">Completed</span>
                                        </span>
									</td>
									<td>
										<span class="badge rounded-pill bg-primary" v-if="device.payment_type==1">Cash</span>
										<span class="badge rounded-pill bg-secondary" v-if="device.payment_type==2">Online</span>
										<span class="badge rounded-pill bg-success" v-if="device.payment_type==3">Both</span>
									</td>
									<td>Total: {{ device.amount }} <br> Cash: {{ device.cash_in_hand }} <br> Online: {{ device.cash_online }} <br> Credit: {{ device.credit_amount }} <br> Balance: {{ device.balance_amount }}</td>
									<td>
										<span class="badge rounded-pill bg-success" v-if="device.payment_status==1">Received</span>
										<span class="badge rounded-pill bg-danger" v-if="device.payment_status==2">Not Received</span>
										<span class="badge rounded-pill bg-warning" v-if="device.payment_status==3">Partially Received</span>
									</td>
                                    <td>
                                        <a class="btn btn-primary btn-sm mt-2 me-2 mb-2" @click="openPaymentModal(device)" v-if="device.payment_status == 2 || device.payment_status == 3">Mark As Payment Received</a>
										<a class="btn btn-warning btn-sm mt-2 me-2 mb-2" @click="openUpdateRenewalModal(device)" v-if="$canUpdateRenewalData()">Update Renewal Data</a>
										<div class="btn btn-info mt-2 me-2 mb-2" @click="generateCertificate(device)">Certificate</div>
										<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.imei} }" class="btn btn-primary btn-sm me-2 mb-2" v-if="!device.vehicle_no">Add Vehicle</router-link><br>
									</td>
								</tr>

							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="12" align="center">No data available in the table</td>
								</tr>

							</tbody>

						</table>
					</div>

					<!----pagination starts --->
					<caption v-if="Boolean(payment_pending.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
								<a class="page-link" href="#" @click.prevent="fetchPendingPayments(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav> 
					<!----pagination ends --->
                </div>

			</div>

			
		</div>

		<!-- Payment Complete Modal -->
		<div class="modal fade" id="paymentModalPending" tabindex="-1" aria-labelledby="paymentModalPendingLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="paymentModalPendingLabel">Mark Payment Received</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<!-- Partial payment summary (when payment_status = 3) -->
						<div v-if="paymentModalDevice && paymentModalDevice.payment_status == 3" class="alert alert-warning mb-3">
							<h6 class="alert-heading">Partial payment details</h6>
							<p class="mb-1">Total: {{ paymentModalDevice.amount }}</p>
							<p class="mb-1">Cash paid: {{ paymentModalDevice.cash_in_hand || 0 }}</p>
							<p class="mb-1">Online paid: {{ paymentModalDevice.cash_online || 0 }}</p>
							<p v-if="paymentModalDevice.payment_id" class="mb-1 text-muted small">Payment ID: {{ paymentModalDevice.payment_id }}</p>
							<hr>
							<p class="mb-0 fw-bold">Balance due: {{ balanceDue }}</p>
						</div>

						<form @submit.prevent="submitPaymentComplete">
							<div class="row">
								<div class="col-12">
									<div class="form-group mb-3">
										<label class="control-label">Payment By<span class="text-danger">*</span></label>
										<select class="form-select" v-model="paymentForm.payment_by" @change="onPaymentByChange" :class="{ 'is-invalid': errors.payment_by }">
											<option value="">--Select Payment By--</option>
											<option value="1">Dealer</option>
											<option value="2">Customer</option>
										</select>
										<div v-if="errors.payment_by" class="invalid-feedback">{{ errors.payment_by }}</div>
									</div>
								</div>

								<div class="col-12" v-if="paymentForm.payment_by == '1'">
									<div class="form-group mb-3">
										<label class="control-label">Payment Dealer<span class="text-danger">*</span></label>
										<div class="position-relative">
											<input
												class="form-control"
												type="text"
												placeholder="Search dealer..."
												v-model="paymentDealerSearch"
												@input="searchPaymentDealer"
												@focus="showPaymentDealerSuggestions = true"
												@blur="hidePaymentDealerSuggestions"
												autocomplete="off"
												:class="{ 'is-invalid': errors.payment_user_id }"
											/>
											<ul
												v-if="showPaymentDealerSuggestions && filteredPaymentDealers.length"
												class="list-group position-absolute w-100"
												style="z-index: 10; max-height: 200px; overflow-y: auto;"
											>
												<li
													v-for="dealer in filteredPaymentDealers"
													:key="dealer.id"
													class="list-group-item list-group-item-action"
													@mousedown.prevent="selectPaymentDealer(dealer)"
												>
													{{ dealer.first_name }}
												</li>
											</ul>
										</div>
										<div v-if="selectedPaymentDealer" class="mt-2">
											<small class="text-success">
												<i class="icofont icofont-check-circled me-1"></i>
												Selected: <strong>{{ selectedPaymentDealer.first_name }}</strong>
											</small>
										</div>
										<div v-if="errors.payment_user_id" class="invalid-feedback d-block">{{ errors.payment_user_id }}</div>
									</div>
								</div>
								<div class="col-12" v-if="paymentForm.payment_by == '2'">
									<div class="form-group mb-3">
										<label class="control-label">Customer<span class="text-danger">*</span></label>
										<div class="position-relative">
											<input
												class="form-control"
												type="text"
												placeholder="Search by name or mobile..."
												v-model="paymentCustomerSearch"
												@input="searchPaymentCustomer"
												@focus="showPaymentCustomerSuggestions = true"
												@blur="hidePaymentCustomerSuggestions"
												autocomplete="off"
												:class="{ 'is-invalid': errors.payment_user_id }"
											/>
											<ul
												v-if="showPaymentCustomerSuggestions && filteredPaymentCustomers.length"
												class="list-group position-absolute w-100"
												style="z-index: 10; max-height: 200px; overflow-y: auto;"
											>
												<li
													v-for="cust in filteredPaymentCustomers"
													:key="cust.id"
													class="list-group-item list-group-item-action"
													@mousedown.prevent="selectPaymentCustomer(cust)"
												>
													{{ cust.company_name }}
													<small v-if="cust.mobile" class="text-muted d-block">{{ cust.mobile }}</small>
												</li>
											</ul>
										</div>
										<div v-if="selectedPaymentCustomer" class="mt-2">
											<small class="text-success">
												<i class="icofont icofont-check-circled me-1"></i>
												Selected: <strong>{{ selectedPaymentCustomer.company_name }}</strong>
											</small>
										</div>
										<div v-if="errors.payment_user_id" class="invalid-feedback d-block">{{ errors.payment_user_id }}</div>
									</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id">
								<div class="col-12">
									<div class="form-group mb-3">
										<label class="control-label">Payment Type<span class="text-danger">*</span></label>
										<select class="form-select" v-model="paymentForm.payment_type" @change="onPaymentTypeChange" :class="{ 'is-invalid': errors.payment_type }">
											<option value="">--Select Payment Type--</option>
											<option value="1">Cash</option>
											<option value="2">Online</option>
											<option value="3">Both</option>
											<option value="4">Advance</option>
										</select>
										<div v-if="errors.payment_type" class="invalid-feedback">{{ errors.payment_type }}</div>
									</div>
								</div>
								<div class="col-12">
									<div class="form-group mb-3">
										<label class="control-label">Payment Date<span class="text-danger">*</span></label>
										<input
											class="form-control"
											type="date"
											v-model="paymentForm.payment_date"
											:class="{ 'is-invalid': errors.payment_date }"
										/>
										<div v-if="errors.payment_date" class="invalid-feedback">{{ errors.payment_date }}</div>
									</div>
								</div>
								<div class="col-12" v-if="paymentForm.payment_type == '2' || paymentForm.payment_type == '3'">
									<div class="form-group mb-3">
										<label class="control-label">Select Bank<span class="text-danger">*</span></label>
										<select
											class="form-select"
											v-model="paymentForm.bank_account_id"
											:class="{ 'is-invalid': errors.bank_account_id }"
										>
											<option value="">--Select Bank--</option>
											<option v-for="bank in banks" :key="bank.id" :value="bank.id">
												{{ bank.bank_name }} ({{ bank.account_number }})
											</option>
										</select>
										<div v-if="errors.bank_account_id" class="invalid-feedback">{{ errors.bank_account_id }}</div>
									</div>
								</div>
								<div class="col-12" v-if="showUserCredit">
									<div class="form-group mb-3">
										<label class="control-label">Amount from advance<span class="text-danger">*</span></label>
										<input
											class="form-control"
											type="number"
											step="0.01"
											min="0"
											placeholder="Enter advance amount"
											v-model="paymentForm.amount_from_credit"
											:class="{ 'is-invalid': errors.amount_from_credit }"
										/>
										<div v-if="userCreditLoading" class="mt-2">
											<small class="text-success">Loading...</small>
										</div>
										<div v-else-if="userCredit && userCredit.credit_available_amount != null" class="mt-2">
											<small class="text-success">Advance available: ₹{{ userCredit.credit_available_amount }}</small>
										</div>
										<div v-else class="mt-2">
											<small class="text-muted">-</small>
										</div>
										<div v-if="errors.amount_from_credit" class="invalid-feedback d-block">{{ errors.amount_from_credit }}</div>
										<div v-if="userCreditError" class="text-danger small mt-1">{{ userCreditError }}</div>
									</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id && (paymentForm.payment_type == '2' || paymentForm.payment_type == '3')">
								<div class="col-12 mb-3">
									<label class="control-label">Online Amount<span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="paymentForm.cash_online" :class="{ 'is-invalid': errors.cash_online }"/>
									<div v-if="errors.cash_online" class="invalid-feedback d-block">{{ errors.cash_online }}</div>
								</div>
								<div class="col-12 mb-3">
									<label class="control-label">Payment ID<span class="text-danger">*</span></label>
									<input class="form-control" type="text" placeholder="Enter payment ID" v-model="paymentForm.payment_id" :class="{ 'is-invalid': errors.payment_id }"/>
									<div v-if="errors.payment_id" class="invalid-feedback d-block">{{ errors.payment_id }}</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id && (paymentForm.payment_type == '1' || paymentForm.payment_type == '3')">
								<div class="col-12 mb-3">
									<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="paymentForm.cash_in_hand" :class="{ 'is-invalid': errors.cash_in_hand }"/>
									<div v-if="errors.cash_in_hand" class="invalid-feedback d-block">{{ errors.cash_in_hand }}</div>
								</div>
							</div>

							<div class="row" v-if="paymentBreakdown">
								<div class="col-12">
									<div class="card border-light">
										<div class="card-body p-2">
											<div class="row text-center">
												<div class="col-6 col-md-3">
													<small class="text-muted">Total Amount</small>
													<div class="fw-bold">₹{{ paymentBreakdown.total }}</div>
												</div>
												<div class="col-6 col-md-3" v-if="paymentForm.payment_type === '2' || paymentForm.payment_type === '3'">
													<small class="text-muted">Online</small>
													<div class="fw-bold">₹{{ paymentBreakdown.online }}</div>
												</div>
												<div class="col-6 col-md-3" v-if="paymentForm.payment_type === '1' || paymentForm.payment_type === '3'">
													<small class="text-muted">Cash</small>
													<div class="fw-bold">₹{{ paymentBreakdown.cash }}</div>
												</div>
												<div class="col-6 col-md-3">
													<small class="text-muted">Balance due</small>
													<div class="fw-bold" :class="parseFloat(balanceDue) > 0 ? 'text-warning' : 'text-success'">
														₹{{ balanceDue }}
													</div>
												</div>
												<div class="col-6 col-md-3">
													<small class="text-muted">Status</small>
													<div class="fw-bold" :class="paymentBreakdown.statusClass">
														{{ paymentBreakdown.statusLabel }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="modal-footer px-0 pb-0">
								<button type="button" class="btn btn-light" @click="closePaymentModal">Close</button>
								<button type="submit" class="btn btn-primary" :disabled="paymentSubmitting">
									<span v-if="paymentSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									{{ paymentSubmitting ? "Saving..." : "Submit" }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<UpdateRenewalDataModal
			ref="updateRenewalModal"
			modal-id="updateRenewalDataModalPending"
			@updated="fetchPendingPayments(active_page_url || undefined)"
		/>

   </div>
</template>


<script>
import { Modal } from 'bootstrap'
import UpdateRenewalDataModal from '@/components/renewal/UpdateRenewalDataModal.vue'

	export default {
		name: "Pending Payments",
		components: { UpdateRenewalDataModal },
		
		data() {

			return {

				pagination: {},
				
				keyword: "",
				listing_length: 20,
				token: "",
				payment_pending:[],
                type: "",
                payment_status: "",

				device: 
				{
					id: "",
					user_name: "",
					payment_status: "",
				},

				pagination: {},

				complete_status: {
					id: "",
				},
				
				errors: {},

				paymentModalInstance: null,
				paymentModalDevice: null,
				paymentForm: {
					payment_type: '',
					payment_by: '',
					payment_user_id: '',
					payment_date: '',
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				},
				paymentSubmitting: false,
				userCredit: null,
				userCreditLoading: false,
				userCreditError: '',
				prevShowUserCredit: false,

				// Payment By selections
				dealers: [],
				dealerSearch: "",
				paymentDealerSearch: "",
				showPaymentDealerSuggestions: false,
				selectedPaymentDealer: null,
				companies: [],
				paymentCustomerSearch: "",
				showPaymentCustomerSuggestions: false,
				selectedPaymentCustomer: null,

				// Bank accounts for online/both
				banks: [],
				
			};
		},
		computed: {
			balanceDue() {
				if (!this.paymentModalDevice) return '0.00';
				const amount = parseFloat(this.paymentModalDevice.amount) || 0;
				const cash = parseFloat(this.paymentModalDevice.cash_in_hand) || 0;
				const online = parseFloat(this.paymentModalDevice.cash_online) || 0;
				const credit = parseFloat(this.paymentModalDevice.credit_amount) || 0;
				const balance = amount - cash - online - credit;
				return (isNaN(balance) ? 0 : balance).toFixed(2);
			},
			/** Cap for amount-from-credit vs order total / remaining balance */
			creditCapNumeric() {
				if (!this.paymentModalDevice) return NaN;
				if (Number(this.paymentModalDevice.payment_status) === 3) {
					return parseFloat(this.balanceDue) || 0;
				}
				return parseFloat(this.paymentModalDevice.amount) || 0;
			},
			showUserCredit() {
				return !!this.paymentForm.payment_user_id && this.paymentForm.payment_type === '4';
			},
			paymentBreakdown() {
				if (!this.paymentModalDevice || !this.paymentForm.payment_type || this.paymentForm.payment_type === '4') return null;

				const total = parseFloat(this.paymentModalDevice.amount) || 0;
				const online = parseFloat(this.paymentForm.cash_online) || 0;
				const cash = parseFloat(this.paymentForm.cash_in_hand) || 0;
				const outstanding = parseFloat(this.balanceDue) || 0;

				let paid = 0;
				if (this.paymentForm.payment_type === '2') {
					paid = online;
				} else if (this.paymentForm.payment_type === '3') {
					paid = online + cash;
				} else if (this.paymentForm.payment_type === '1') {
					paid = cash;
				} else {
					return null;
				}

				const eps = 0.01;
				const diff = paid - outstanding;
				let statusLabel = 'Partial';
				let statusClass = 'text-warning';
				if (Math.abs(diff) < eps) {
					statusLabel = 'Full';
					statusClass = 'text-success';
				} else if (diff > eps) {
					statusLabel = 'Advance';
					statusClass = 'text-info';
				}

				if (this.paymentForm.payment_type === '2') {
					return { total, online, cash: 0, statusLabel, statusClass };
				}
				if (this.paymentForm.payment_type === '3') {
					return { total, online, cash, statusLabel, statusClass };
				}
				return { total, online: 0, cash, statusLabel, statusClass };
			},
			filteredPaymentDealers() {
				if (!this.paymentDealerSearch.trim()) return this.dealers;
				const q = this.paymentDealerSearch.toLowerCase();
				return this.dealers.filter(d => (d.first_name || '').toLowerCase().includes(q));
			},
			filteredPaymentCustomers() {
				if (!this.paymentCustomerSearch.trim()) return this.companies;
				const q = this.paymentCustomerSearch.toLowerCase().trim();
				return this.companies.filter((c) => {
					const name = (c.company_name || "").toLowerCase();
					const mobile = String(c.mobile || "").toLowerCase();
					return name.includes(q) || mobile.includes(q);
				});
			},
		},
		watch: {
			'paymentForm.payment_user_id': 'maybeFetchUserCredit',
			'paymentForm.payment_type': 'maybeFetchUserCredit',
		},
		mounted() {
			const el = document.getElementById('paymentModalPending');
			if (el) this.paymentModalInstance = new Modal(el);
			this.getToken();
			this.fetchDealers();
			this.fetchCompanies();
			this.fetchBankAccounts();
		},

		created() {
			this.fetchPendingPayments();
		},

		methods: {
			openUpdateRenewalModal(device) {
				this.$refs.updateRenewalModal?.open(device);
			},

			getSelectedUserId(entity) {
				return entity && entity.user_id ? entity.user_id : '';
			},

			todayIsoDate() {
				return new Date().toISOString().slice(0, 10);
			},

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchPendingPayments(page_url = null) {
				this.getToken();
				let url = "/staffs/renewalPaymentPending?limit=" + this.listing_length  +  "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.payment_pending = responseData.payment_pending.data;
						this.pagination = responseData.payment_pending.links;
						this.from = responseData.payment_pending.from;
						this.to = responseData.payment_pending.to;
						this.total = responseData.payment_pending.total;
						
					})
					.catch((err) => console.log(err));
			},


			generateCertificate(device) 
			{
				this.getToken();
				let page_url = "/staffs/renewelCertificate?device_id=" + device.id;
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/pdf" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download ="Renewal_certificate" + device.vehicle_no + ".pdf";

					const url = URL.createObjectURL(blob);

					window.open(url, "_blank");

					link.click();
						
				})
				.catch((err) => console.log(err));
			},

			openPaymentModal(device) {
				this.getToken();
				this.paymentModalDevice = device;
				this.userCredit = null;
				this.userCreditError = '';
				this.userCreditLoading = false;
				this.prevShowUserCredit = false;
				this.paymentForm = {
					payment_type: '',
					payment_by: '1',
					payment_user_id: '',
					payment_date: this.todayIsoDate(),
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				};
				this.paymentDealerSearch = '';
				this.selectedPaymentDealer = null;
				this.paymentCustomerSearch = '';
				this.selectedPaymentCustomer = null;
				this.showPaymentDealerSuggestions = false;
				this.showPaymentCustomerSuggestions = false;
				this.errors = {};

				const dealerId = device?.dealer_id != null ? device.dealer_id : null;
				if (dealerId != null) {
					const dealer = this.dealers.find(
						(d) => d.id == dealerId || String(d.id) === String(dealerId)
					);
					if (dealer) {
						this.selectedPaymentDealer = dealer;
						this.paymentDealerSearch = dealer.first_name || '';
						this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
					} else {
						this.paymentDealerSearch = device?.dealer_name || '';
						this.selectedPaymentDealer = {
							id: dealerId,
							first_name: device?.dealer_name || '',
							user_id: device?.dealer_user_id || '',
						};
						this.paymentForm.payment_user_id =
							device?.dealer_user_id != null && device?.dealer_user_id !== ''
								? String(device.dealer_user_id)
								: '';
					}
				}

				if (this.paymentModalInstance) this.paymentModalInstance.show();
			},

			closePaymentModal() {
				if (this.paymentModalInstance) this.paymentModalInstance.hide();
				this.paymentModalDevice = null;
				this.userCredit = null;
				this.userCreditError = '';
				this.prevShowUserCredit = false;
				this.paymentForm = {
					payment_type: '',
					payment_by: '',
					payment_user_id: '',
					payment_date: '',
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				};
				this.errors = {};
			},

			onPaymentByChange() {
				this.paymentForm.payment_user_id = '';
				this.paymentForm.payment_type = '';
				this.paymentForm.amount_from_credit = '';
				this.paymentForm.bank_account_id = '';
				this.selectedPaymentDealer = null;
				this.selectedPaymentCustomer = null;
				this.paymentDealerSearch = '';
				this.paymentCustomerSearch = '';
				this.errors.payment_user_id = '';
				this.userCredit = null;
				this.userCreditError = '';

				if (this.paymentForm.payment_by === '1' && this.paymentModalDevice?.dealer_id != null) {
					const dealerId = this.paymentModalDevice.dealer_id;
					const dealer = this.dealers.find(
						(d) => d.id == dealerId || String(d.id) === String(dealerId)
					);
					if (dealer) {
						this.selectedPaymentDealer = dealer;
						this.paymentDealerSearch = dealer.first_name || '';
						this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
					} else {
						this.paymentDealerSearch = this.paymentModalDevice?.dealer_name || '';
						this.selectedPaymentDealer = {
							id: dealerId,
							first_name: this.paymentModalDevice?.dealer_name || '',
							user_id: this.paymentModalDevice?.dealer_user_id || '',
						};
						this.paymentForm.payment_user_id =
							this.paymentModalDevice?.dealer_user_id != null &&
							this.paymentModalDevice?.dealer_user_id !== ''
								? String(this.paymentModalDevice.dealer_user_id)
								: '';
					}
				}
			},

			onPaymentTypeChange() {
				if (this.paymentForm.payment_type === '2') {
					this.paymentForm.cash_in_hand = '';
				} else if (this.paymentForm.payment_type === '1') {
					this.paymentForm.cash_online = '';
					this.paymentForm.payment_id = '';
				} else if (this.paymentForm.payment_type === '4') {
					this.paymentForm.cash_in_hand = '';
					this.paymentForm.cash_online = '';
					this.paymentForm.payment_id = '';
				}
				if (!(this.paymentForm.payment_type === '2' || this.paymentForm.payment_type === '3')) {
					this.paymentForm.bank_account_id = '';
				}
				if (this.paymentForm.payment_type !== '4') {
					this.paymentForm.amount_from_credit = '';
				}
			},

			async maybeFetchUserCredit() {
				const nowVisible = this.showUserCredit;
				const wasVisible = this.prevShowUserCredit;

				if (!nowVisible) {
					this.userCredit = null;
					this.userCreditError = '';
					this.userCreditLoading = false;
					this.paymentForm.amount_from_credit = '';
					this.prevShowUserCredit = nowVisible;
					return;
				}
				if (!this.paymentForm.payment_user_id) return;

				if (!wasVisible) {
					const cap = this.creditCapNumeric;
					this.paymentForm.amount_from_credit =
						!isNaN(cap) && cap > 0 ? String(cap) : this.paymentModalDevice?.amount || '';
					this.errors.amount_from_credit = '';
				}

				await this.fetchUserCredit();
				this.prevShowUserCredit = nowVisible;
			},

			async fetchUserCredit() {
				try {
					this.getToken();
					this.userCreditLoading = true;
					this.userCreditError = '';

					const response = await this.$axios.get('/staffs/getUserCredit', {
						params: { user_id: this.paymentForm.payment_user_id },
						headers: { Authorization: `Bearer ${this.token}` },
					});

					const ok = response.data?.status === true || response.data?.status === 'true';
					if (!ok) {
						this.userCredit = null;
						this.userCreditError = response.data?.message || 'Failed to fetch credit balance';
						return;
					}

					this.userCredit = response.data?.data?.user_credit || null;
				} catch (e) {
					this.userCredit = null;
					this.userCreditError = e?.response?.data?.message || 'Failed to fetch credit balance';
				} finally {
					this.userCreditLoading = false;
				}
			},

			fetchDealers() {
				this.getToken();
				return this.$axios
					.get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.dealers = Array.isArray(data) ? data : (data.data || []);
					})
					.catch(() => {
						this.dealers = [];
					});
			},

			fetchCompanies() {
				this.getToken();
				return this.$axios
					.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.companies = Array.isArray(data) ? data : (data.data || []);
					})
					.catch(() => {
						this.companies = [];
					});
			},

			fetchBankAccounts() {
				this.getToken();
				return this.$axios
					.get("/staffs/bankAccounts", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.banks = Array.isArray(data) ? data : (data.data || []);
					})
					.catch(() => {
						this.banks = [];
					});
			},

			searchPaymentDealer() {
				this.showPaymentDealerSuggestions = true;
			},
			hidePaymentDealerSuggestions() {
				setTimeout(() => { this.showPaymentDealerSuggestions = false; }, 200);
			},
			selectPaymentDealer(dealer) {
				this.selectedPaymentDealer = dealer;
				this.paymentDealerSearch = dealer.first_name;
				this.showPaymentDealerSuggestions = false;
				this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
				this.errors.payment_user_id = '';
			},

			searchPaymentCustomer() {
				this.showPaymentCustomerSuggestions = true;
			},
			hidePaymentCustomerSuggestions() {
				setTimeout(() => { this.showPaymentCustomerSuggestions = false; }, 200);
			},
			selectPaymentCustomer(cust) {
				this.selectedPaymentCustomer = cust;
				this.paymentCustomerSearch = cust.company_name;
				this.showPaymentCustomerSuggestions = false;
				this.paymentForm.payment_user_id = this.getSelectedUserId(cust);
				this.errors.payment_user_id = '';
			},

			submitPaymentComplete() {
				this.getToken();
				this.errors = {};

				if (!this.paymentForm.payment_by) {
					this.errors.payment_by = 'Please select payment by.';
				}
				if (!this.paymentForm.payment_user_id) {
					this.errors.payment_user_id = 'Please select payment user.';
				}
				if (!this.paymentForm.payment_date) {
					this.errors.payment_date = 'Payment date is required.';
				}

				const pt = this.paymentForm.payment_type;
				if (!pt) {
					this.errors.payment_type = 'Payment type is required.';
				} else if (pt === '2') {
					if (!this.paymentForm.cash_online || parseFloat(this.paymentForm.cash_online) <= 0) {
						this.errors.cash_online = 'Online amount is required.';
					}
					if (!this.paymentForm.bank_account_id) {
						this.errors.bank_account_id = 'Bank account is required for online payment.';
					}
					if (!this.paymentForm.payment_id || !String(this.paymentForm.payment_id).trim()) {
						this.errors.payment_id = 'Payment ID is required for online payment.';
					}
				} else if (pt === '1') {
					if (!this.paymentForm.cash_in_hand || parseFloat(this.paymentForm.cash_in_hand) <= 0) {
						this.errors.cash_in_hand = 'Cash amount is required.';
					}
				} else if (pt === '3') {
					if (!this.paymentForm.cash_online || parseFloat(this.paymentForm.cash_online) <= 0) {
						this.errors.cash_online = 'Online amount is required.';
					}
					if (!this.paymentForm.cash_in_hand || parseFloat(this.paymentForm.cash_in_hand) <= 0) {
						this.errors.cash_in_hand = 'Cash amount is required.';
					}
					if (!this.paymentForm.bank_account_id) {
						this.errors.bank_account_id = 'Bank account is required for online/both payment.';
					}
					if (!this.paymentForm.payment_id || !String(this.paymentForm.payment_id).trim()) {
						this.errors.payment_id = 'Payment ID is required for online payment.';
					}
				}

				if (this.showUserCredit) {
					const creditAmt = parseFloat(this.paymentForm.amount_from_credit);
					if (!this.paymentForm.amount_from_credit || isNaN(creditAmt) || creditAmt <= 0) {
						this.errors.amount_from_credit = 'Amount from credit is required.';
					} else {
						if (this.userCredit && this.userCredit.credit_available_amount != null) {
							const available = parseFloat(this.userCredit.credit_available_amount);
							if (!isNaN(available) && creditAmt > available) {
								this.errors.amount_from_credit = 'Amount from credit cannot exceed available credit.';
							}
						}
						const cap = this.creditCapNumeric;
						if (!isNaN(cap) && cap >= 0 && creditAmt > cap) {
							this.errors.amount_from_credit = 'Amount from credit cannot exceed the payable amount.';
						}
					}
				}

				if (Object.keys(this.errors).length) return;
				if (this.paymentSubmitting) return;

				this.paymentSubmitting = true;

				const payload = {
					device_id: this.paymentModalDevice.id,
					payment_type: parseInt(pt, 10),
					payment_date: this.paymentForm.payment_date,
					bank_account_id: '',
					payment_id: '',
					cash_in_hand: 0,
					cash_online: 0,
					amount_from_credit: this.showUserCredit
						? (this.paymentForm.amount_from_credit ? parseFloat(this.paymentForm.amount_from_credit) : 0)
						: 0,
				};

				if (this.paymentForm.payment_by && this.paymentForm.payment_user_id) {
					payload.payment_user_type = this.paymentForm.payment_by;
					payload.payment_user_id = this.paymentForm.payment_user_id;
				}

				if (pt === '2' || pt === '3') {
					payload.bank_account_id = this.paymentForm.bank_account_id;
					payload.cash_online = parseFloat(this.paymentForm.cash_online) || 0;
					payload.payment_id = String(this.paymentForm.payment_id).trim();
				}
				if (pt === '1' || pt === '3') {
					payload.cash_in_hand = parseFloat(this.paymentForm.cash_in_hand) || 0;
				}

				this.$axios
					.post('/staffs/paymentComplete', payload, { headers: { Authorization: 'Bearer ' + this.token } })
					.then((response) => {
						this.paymentSubmitting = false;
						if (response.data.status) {
							this.$swal(
								'',
								this.$extractApiMessage(response.data.message) || 'Payment recorded successfully.',
								'success'
							);
							this.closePaymentModal();
							this.fetchPendingPayments(this.active_page_url);
						} else {
							this.applyPaymentApiErrors(response.data);
							this.$swal(
								'',
								this.$getApiErrorMessage(response.data, 'Failed to record payment.'),
								'error'
							);
						}
					})
					.catch((error) => {
						this.paymentSubmitting = false;
						const data = error.response?.data || {};
						this.applyPaymentApiErrors(data);
						this.$swal('', this.$getApiErrorMessage(error, 'Something went wrong.'), 'error');
					});
			},

			applyPaymentApiErrors(data) {
				const source =
					(data?.errors && typeof data.errors === 'object' && !Array.isArray(data.errors) && data.errors) ||
					(data?.message && typeof data.message === 'object' && !Array.isArray(data.message) && data.message) ||
					null;
				if (!source) return;
				this.errors = Object.keys(source).reduce((acc, k) => {
					const v = source[k];
					acc[k] = Array.isArray(v) ? v[0] : v;
					return acc;
				}, {});
			},


			
		},
	};
</script>
